import * as React from "react";

export const GuestFooter = () => (<p className="m-t"><small>Vitalograph Web Portal &copy; 2015 - 2024 Vitalograph Ltd</small></p>)
